module.exports = "/_next/static/images/4f38aad30859746d6f0d5fb1aa4945f9-filter.svg";